module.exports = ['$translateProvider', function ($translateProvider) {
    $translateProvider.useSanitizeValueStrategy('sanitize');
    $translateProvider.preferredLanguage('it');
}];



//////////////////
// WEBPACK FOOTER
// ./src/gateway/core/configs/TranslateProvider.js
// module id = 196
// module chunks = 2